
import Model from '@/app/Model'
import { Permission } from '@/models/Permission'

export class Module extends Model {
	static fields () {
		return {
			id: null,
			name: null,
			price: 0
		}
	}

	static hasMany () {
		return {
			permissions: Permission
		}
	}
}

export function createModule (data) {
	return Object.freeze(new Module(data))
}
